interface RoleLabelSource {
  position?: { name?: string | null } | null;
  userFunction?: { name?: string | null } | null;
}

/**
 * Role label for a slot/shift the employee signs up for. The project-specific position name (e.g.
 * "Bardienst", "Servicedienst") wins over the generic, org-wide function name; falls back to the
 * function name and finally to `fallback` when neither is set. Empty strings count as absent. See
 * admin#373.
 */
export function getSlotRoleLabel(slot: RoleLabelSource | null | undefined, fallback = ""): string {
  return slot?.position?.name || slot?.userFunction?.name || fallback;
}
